/* Theme-originated event tracking (MVAE-190).
   The WhatsApp click is the theme's own conversion signal. GA4 / Meta base
   pixels run inside Shopify Customer Events (Web Pixels), which are sandboxed
   and do NOT expose window.gtag / window.fbq to the theme — so to reach them we
   PUBLISH a custom event that a Custom Pixel subscribes to. Each CTA names its
   own event via data-wa-event, so the product "Comprar por WhatsApp" button
   (whatsapp_buy_click) and the floating button (whatsapp_float_click) reach GA4
   as TWO distinct events; every other WhatsApp link falls back to whatsapp_click:

     // In a Custom Pixel (Settings > Customer events) — forward each named event:
     ['whatsapp_buy_click', 'whatsapp_float_click', 'whatsapp_click'].forEach((name) =>
       analytics.subscribe(name, (event) => {
         // forward event.customData to GA4 as its own event `name`
       }));

   We also emit a DOM CustomEvent (for a GTM container installed in the theme
   head) and fall back to gtag/fbq/dataLayer if any are present in the main
   window. Safe no-op if no destination is wired. */
(function () {
  function track(name, params) {
    params = params || {};
    // 1) Shopify Web Pixels custom event (the supported bridge to sandboxed pixels)
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) { /* ignore */ }
    // 2) DOM CustomEvent (for a theme-level GTM container / listeners)
    try { document.dispatchEvent(new CustomEvent(name, { detail: params })); } catch (e) { /* ignore */ }
    // 3) Direct fallbacks if analytics libs are loaded in the main window
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params);
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
  }

  document.addEventListener('click', function (e) {
    var wa = e.target.closest('[data-whatsapp]');
    if (!wa) return;
    // Each CTA may declare its own GA4 event name via data-wa-event; the rest of
    // the WhatsApp links fall back to the generic whatsapp_click.
    var name = wa.getAttribute('data-wa-event') || 'whatsapp_click';
    var params = { link_url: wa.href, location: wa.getAttribute('data-wa-location') || 'site' };
    // Enrich the product buy CTA with the product it points to, when present.
    var title = wa.getAttribute('data-wa-title');
    if (title) params.product_title = title;
    var code = wa.getAttribute('data-wa-code');
    if (code) params.product_code = code;
    track(name, params);
  });
})();
